import { wrapClient } from './src/utils/wrapRootElement';

export const wrapRootElement = wrapClient;
